export default {
  computed: {
    /* ----------------------------------------
     * PLP guard
     * ---------------------------------------- */
    isPlpActive() {
      return this.isPlp === true;
    },

    /* ----------------------------------------
     * Campaign detection
     * ---------------------------------------- */
    hasPlpCampaign() {
      if (!this.isPlpActive) return false;

      const campaign = this.priorityCampaign?.value;
      if (!campaign || campaign.enhancedUI !== true) return false;

      if (Number(campaign.maxDiscount ?? 0) > 0) return true;

      const title = String(campaign.campaignTitle || "")
        .toLowerCase()
        .replace(/[\s_]+/g, "-");

      return [
        "velocity-campaign",
        "member-campaign",
        "was-now",
        "intro-price-campaign",
      ].includes(title);
    },

    /* ----------------------------------------
     * Campaign price (MIN ONLY)
     * ---------------------------------------- */
    plpCampaignMinNow() {
      if (!this.hasPlpCampaign) return null;
      return this.applyPlpDiscount(this.minNow, this.minWas);
    },
  },

  methods: {
    applyPlpDiscount(now, was) {
      const discount = Number(this.priorityCampaign?.value?.maxDiscount ?? 0);
      if (!discount || !now) return now;

      const rrpBase = Number(was) > Number(now) ? Number(was) : Number(now);
      const discounted = rrpBase - (rrpBase * discount) / 100;

      return Math.ceil(Math.min(discounted, now));
    },
  },
};
